const daysSortedByKey = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const sortedDays = function (a, b) {
  return daysSortedByKey.indexOf(a) - daysSortedByKey.indexOf(b);
};

const splitHoursStringWithTwoDots = (str) => {
  const middle = Math.ceil(str.length / 2);
  const hours = str.slice(0, middle);
  const minutes = str.slice(middle);
  return `${hours}:${minutes}`;
};

const timeSetSplitter = '|';
const fromToSplitter = '-';

const fromArrayToStringKey = (timesArray) =>
  (timesArray || []).map(({ from, to }) => `${from}${fromToSplitter}${to}`).join(timeSetSplitter);

const fromStringKeyToArray = (stringKey) =>
  stringKey
    .split(timeSetSplitter)
    .filter((notEmptyString) => notEmptyString)
    .map((hours) => {
      const [from, to] = hours.split(fromToSplitter);
      return { from, to };
    });

const consecutiveSorted = (timeFrames) => (acc, weekDay) => {
  const timesString = fromArrayToStringKey(timeFrames[weekDay]);
  const currentAccDays = acc[timesString] || [];

  return {
    ...acc,
    [timesString]: [...currentAccDays, weekDay],
  };
};

const getConsecutiveEqualDays = (sortedDaysByKey, timeFrames) => {
  return sortedDaysByKey.reduce(consecutiveSorted(timeFrames), {});
};

const parseFromTimeFramesKey = (timeFramesKey) => {
  return fromStringKeyToArray(timeFramesKey);
};

export { sortedDays, splitHoursStringWithTwoDots, getConsecutiveEqualDays, parseFromTimeFramesKey };
